<template>
  <modal v-model="show"
         :width="width"
         :title="editMode ? title : undefined"
         content-class="modal modal-round modal-device">

    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset()">
      {{dataActivatorText}}
    </button>

    <app-user-create-body @close="show = false"
                          :permissions="displayedPermissions"
                          v-if="createMode"></app-user-create-body>

    <app-user-edit-body @close="show = false"
                        v-if="editMode"></app-user-edit-body>

    <app-user-settings-body v-if="settingsMode"
                            :permissions="displayedPermissions"
                            :entityId="entityId"
                            @close="show = false"></app-user-settings-body>

    <app-user-bindings-body @close="show = false"
                            v-if="bindingsMode"></app-user-bindings-body>

  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import dataEntityProp from "@mixins/data-entity-prop";
import EventBus from "@packages/event-bus";
import AppUserBindingsBody from "./components/UserBindingsBody";
import AppUserCreateBody from "./components/UserCreateBody";
import AppUserEditBody from "./components/UserEditBody";
import AppUserSettingsBody from "./components/UserSettingsBody";

export default {
  components: {
    Modal,
    AppUserCreateBody,
    AppUserEditBody,
    AppUserSettingsBody,
    AppUserBindingsBody,
  },

  data() {
    return {
      show: false,
      mode: null,
      permissions: [],
      partnerManageablePermissions: [],
      entityId: undefined
    };
  },

  props: {
    dataActivatorText: {
      type: String,
      required: true,
    },
  },

  computed: {
    title() {
      return this.isEstablishment ? this.$t('message.admGenerics.message.establishment') : this.$t('message.admGenerics.message.partner');
    },

    isEstablishment() {
      return this.entity === "establishments";
    },

    createMode() {
      return this.mode === "create";
    },

    editMode() {
      return this.mode === "edit";
    },

    settingsMode() {
      return this.mode === "settings";
    },

    bindingsMode() {
      return this.mode === "bindings";
    },

    width() {
      if (this.settingsMode) return 540;

      if (this.bindingsMode) return 1240;

      return 700;
    },

    isPartnerLogged() {
      return (
        this.$store.state.users.user != null &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },

    displayedPermissions() {
      return this.isPartnerLogged ? 
        this.permissions.filter(permission => this.partnerManageablePermissions.includes(permission.key)) :
        this.permissions
    }
  },

  created() {
    this.loadPermissions();

    if(this.isPartnerLogged) {
      this.loadPartnerManageablePermissions()
    }
  },

  methods: {
    reset(user) {
      if (!user) this.mode = "create";

      this.$nextTick(() =>
        EventBus.$emit("RESET_USER_MODAL", {
          entity: this.entity,
          user,
        })
      );
    },

    async loadPermissions() {
      const userAccountType =
        this.entity === "partners" ? "PARCEIRO" : "ESTABELECIMENTO";

      this.permissions = await this.$api.account.listPermissions({
        accountType: userAccountType,
      });

    },

    async loadPartnerManageablePermissions() {
      const partnerId = this.$store.state.users.user.accountId
      this.partnerManageablePermissions = await this.$api.partners.getEstablishmentManageablePermission(partnerId)    
    },

    async load(id) {
      const user = await this.$loader[this.entity].find(id);

      this.reset(user);
      this.entityId = id;
      this.show = true;
    },

    edit(id) {
      this.mode = "edit";
      this.load(id);
    },

    settings(id) {
      this.mode = "settings";
      this.load(id);
    },

    bindings(id) {
      this.mode = "bindings";
      this.load(id);
    },
  },

  mixins: [dataEntityProp],

  mounted() {
    EventBus.$on("EDIT_USER_DATA", this.edit);
    EventBus.$on("EDIT_USER_SETTINGS", this.settings);
    EventBus.$on("EDIT_USER_BINDINGS", this.bindings);
  },

  beforeDestroy() {
    EventBus.$off("EDIT_USER_DATA", this.edit);
    EventBus.$off("EDIT_USER_SETTINGS", this.settings);
    EventBus.$off("EDIT_USER_BINDINGS", this.bindings);
  },
};
</script>

<style scoped>
</style>
